var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelThreadsFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "#000",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.781 8.562q-.075-.037-.152-.072c-.09-1.706-.993-2.683-2.51-2.693H9.1c-.908 0-1.662.4-2.126 1.127l.834.59c.347-.543.891-.659 1.292-.659h.014q.752.007 1.12.446.267.32.355.878a6.2 6.2 0 0 0-1.433-.071c-1.442.085-2.37.954-2.307 2.16.031.612.327 1.139.831 1.483.427.29.976.433 1.547.4.755-.042 1.346-.34 1.759-.883.313-.412.512-.947.6-1.62.359.224.625.518.772.873.25.602.265 1.592-.517 2.398-.685.707-1.51 1.013-2.754 1.022-1.38-.01-2.425-.468-3.104-1.359-.636-.834-.964-2.04-.977-3.582.013-1.543.341-2.748.977-3.582.679-.891 1.723-1.349 3.104-1.36 1.39.011 2.453.47 3.158 1.366.346.44.607.992.778 1.635L14 6.79q-.312-1.19-.982-2.042C12.114 3.6 10.793 3.012 9.09 3h-.006c-1.7.012-3.007.603-3.885 1.755C4.417 5.78 4.014 7.207 4 8.995v.009c.014 1.789.417 3.216 1.198 4.241.878 1.152 2.185 1.743 3.885 1.755h.006c1.512-.01 2.577-.42 3.454-1.324a3.32 3.32 0 0 0 .735-3.58c-.271-.653-.789-1.184-1.497-1.534m-2.609 2.532c-.632.037-1.288-.256-1.32-.883-.025-.465.32-.984 1.36-1.046q.177-.01.35-.01.568 0 1.051.11c-.12 1.543-.822 1.794-1.44 1.83"
}))));
export default SvgGemChannelThreadsFilled;